import * as React from 'react'
import { useOutletContext } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import LocationHolidays from 'modules/locations/components/Holidays'
import type Location from 'modules/locations/store/models/Location'
import companyHolidays from 'modules/timeoff/store/collections/companyHolidays'

type Props = Record<string, unknown>

const HolidaysComponent = ({ children }: React.PropsWithChildren<Props>) => {
  const { location } = useOutletContext<{ location: Location }>()

  const { loading } = useAsyncData(() => companyHolidays.fetch(), [])

  return (
    <ResponsivePage.Body variant="wide" loading={loading} error={null} showHeader={false}>
      {children}
      <LocationHolidays location={location} />
    </ResponsivePage.Body>
  )
}

export default HolidaysComponent
